/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'expenseCategories/investments': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M6 16.5l-3 2.94V12.5a1.5 1.5 0 013 0m5 2.16l-1.57-1.34L8 14.64V8.5a1.5 1.5 0 013 0m5 4.5l-3 3V4.5a1.5 1.5 0 013 0m2.81 8.31L17 11h5v5l-1.79-1.79L13 21.36l-3.47-3.02L5.75 22H3l6.47-6.34L13 18.64" _fill="#000" fill-rule="evenodd"/>'
  }
})
